import React from 'react';

// Erbity official logo.
// - Light background: /erbity-logo.png (pink tile + black "Erbity" wordmark)
// - Dark background:  /erbity-logo-dark.png (same pink tile + white "Erbity" wordmark,
//   pre-rendered by converting the black word pixels to white so the tile stays intact)
export default function Logo({ size = 38, tone = 'dark', showTagline = true }) {
  const isOnDark = tone === 'light';
  const imgHeight = size;
  const src = isOnDark ? '/erbity-logo-dark.png' : '/erbity-logo.png';

  return (
    <div className="flex items-center gap-3 select-none">
      <img
        src={src}
        alt="Erbity"
        style={{ height: imgHeight, width: 'auto', objectFit: 'contain' }}
      />
      {showTagline && (
        <span
          className={`hidden md:inline text-[9px] uppercase tracking-[0.22em] pl-3 border-l ${
            isOnDark ? 'border-white/20 text-white/60' : 'border-[#EADDE2] text-[#7A6A72]'
          }`}
        >
          Talent&nbsp;.&nbsp;Engineered
        </span>
      )}
    </div>
  );
}
